import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import HomePage from "@/pages/HomePage";
import CardDetailPage from "@/pages/CardDetailPage";
import ComparePage from "@/pages/ComparePage";
import AIRecommendPage from "@/pages/AIRecommendPage";
import AdminPage from "@/pages/AdminPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import FavoritesPage from "@/pages/FavoritesPage";

function App() {
  return (
    <BrowserRouter>
      <div className="min-h-screen bg-background">
        <Navbar />
        <main className="pt-16">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/cards/:id" element={<CardDetailPage />} />
            <Route path="/compare" element={<ComparePage />} />
            <Route path="/recommend" element={<AIRecommendPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/admin/login" element={<AdminLoginPage />} />
            <Route path="/favorites" element={<FavoritesPage />} />
          </Routes>
        </main>
        <Toaster richColors position="top-right" />
      </div>
    </BrowserRouter>
  );
}

export default App;
